import { CustomTheme } from '@nemuru-eng/js-api-client';

export const themedUrls: [string, CustomTheme][] = [
  ['cpc.dev.nemuru.io', CustomTheme.CAIXABANK],
  ['cpc.stg.nemuru.io', CustomTheme.CAIXABANK],
  ['cpc.nemuru.com', CustomTheme.CAIXABANK],
  ['astara.stg.nemuru.io', CustomTheme.NEMURU],
  ['astara.nemuru.com', CustomTheme.NEMURU],
  ['vaillant.dev.nemuru.io', CustomTheme.VAILLANT],
  ['vaillant.stg.nemuru.io', CustomTheme.VAILLANT],
  ['vaillant.nemuru.com', CustomTheme.VAILLANT],
];
